/**
 * Rotating popup messages. Only true statements about the offer (no fake purchases).
 */
export interface PopupMessage {
  icon: string
  title: string
  detail: string
}

export const popupMessages: PopupMessage[] = [
  { icon: '⚡', title: 'Accès numérique immédiat', detail: 'Commencez juste après l’achat' },
  { icon: '🛡️', title: 'Garantie de 7 jours', detail: 'Satisfait ou remboursé' },
  { icon: '🌿', title: '6 modules + 5 bonus', detail: 'Le système complet 6 en 1' },
  { icon: '🔥', title: 'Offre de lancement : 27 €', detail: 'Au lieu de 97 €' },
]
